/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "features/growth/v3/tracking/cohorting_event.proto" (package "fubo.tv.proto.features.growth.v3.tracking", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Navigation } from "../../../../common/v3/generic/navigation";
import { Cohorting } from "../../../../common/v3/generic/cohorting";
import { Location } from "../../../../common/v3/generic/location";
import { Device } from "../../../../common/v3/generic/device";
import { AppContext } from "../../../../common/v3/generic/app_context";
import { UserProperties } from "../../../../common/v3/generic/user_properties";
import { FuboContext } from "../../../../common/v3/generic/fubo_context";
import { Core } from "../../../../common/v3/generic/core";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.CohortingEvent
 */
export interface CohortingEvent {
    /**
     * @generated from protobuf field: optional string anonymous_id = 1;
     */
    anonymous_id?: string;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.EventName event = 2;
     */
    event: CohortingEvent_EventName;
    /**
     * @generated from protobuf field: string message_id = 3;
     */
    message_id: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp received_at = 4;
     */
    received_at?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 5;
     */
    sent_at?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 6;
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: string type = 7;
     */
    type: string;
    /**
     * @generated from protobuf field: optional string user_id = 8;
     */
    user_id?: string;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.Properties properties = 9;
     */
    properties?: CohortingEvent_Properties;
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.Properties
 */
export interface CohortingEvent_Properties {
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.Core core = 1;
     */
    core?: Core;
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.FuboContext fubo_context = 2;
     */
    fubo_context?: FuboContext;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.UserProperties user_properties = 3;
     */
    user_properties?: UserProperties;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.AppContext app_context = 4;
     */
    app_context?: AppContext;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Device device = 5;
     */
    device?: Device;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Location location = 6;
     */
    location?: Location;
    /**
     * @generated from protobuf field: repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting = 7;
     */
    cohorting: Cohorting[];
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Navigation navigation = 8;
     */
    navigation?: Navigation;
}
/**
 * @generated from protobuf enum fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.EventName
 */
export enum CohortingEvent_EventName {
    /**
     * @generated from protobuf enum value: cohorting_event = 0;
     */
    cohorting_event = 0
}
// @generated message type with reflection information, may provide speed optimized methods
class CohortingEvent$Type extends MessageType<CohortingEvent> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.CohortingEvent", [
            { no: 1, name: "anonymous_id", kind: "scalar", localName: "anonymous_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "c6ced3d1-694c-4658-83a6-719f6cdcfb47", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A pseudo-unique substitute for a User ID, for cases when you don\u2019t have an absolutely unique identifier, an anonymous_id or a user_id is required." } },
            { no: 2, name: "event", kind: "enum", T: () => ["fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.EventName", CohortingEvent_EventName], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "cohorting_event", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Event name." } },
            { no: 3, name: "message_id", kind: "scalar", localName: "message_id", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "6ac0e185-427b-40fb-b213-e624d0c1b3e0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A unique identifier for each message that lets you find an individual message across the API." } },
            { no: 4, name: "received_at", kind: "message", localName: "received_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of receiving event in RFC 3339 format, enriched by Ingestion Backend" } },
            { no: 5, name: "sent_at", kind: "message", localName: "sent_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of sending event in RFC 3339 format." } },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of event in RFC 3339 format." } },
            { no: 7, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "track", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Type of message, track or identify." } },
            { no: 8, name: "user_id", kind: "scalar", localName: "user_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1234567891011", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Unique identifier for the user, an anonymous_id or a user_id is required." } },
            { no: 9, name: "properties", kind: "message", T: () => CohortingEvent_Properties }
        ], { "fubo.tv.proto.common.v3.custom.bigquery_opts": { tableName: "cohorting_event" } });
    }
    create(value?: PartialMessage<CohortingEvent>): CohortingEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event = 0;
        message.message_id = "";
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<CohortingEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CohortingEvent): CohortingEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string anonymous_id */ 1:
                    message.anonymous_id = reader.string();
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.EventName event */ 2:
                    message.event = reader.int32();
                    break;
                case /* string message_id */ 3:
                    message.message_id = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp received_at */ 4:
                    message.received_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.received_at);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 5:
                    message.sent_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sent_at);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 6:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string type */ 7:
                    message.type = reader.string();
                    break;
                case /* optional string user_id */ 8:
                    message.user_id = reader.string();
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.Properties properties */ 9:
                    message.properties = CohortingEvent_Properties.internalBinaryRead(reader, reader.uint32(), options, message.properties);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CohortingEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string anonymous_id = 1; */
        if (message.anonymous_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.anonymous_id);
        /* fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.EventName event = 2; */
        if (message.event !== 0)
            writer.tag(2, WireType.Varint).int32(message.event);
        /* string message_id = 3; */
        if (message.message_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message_id);
        /* optional google.protobuf.Timestamp received_at = 4; */
        if (message.received_at)
            Timestamp.internalBinaryWrite(message.received_at, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 5; */
        if (message.sent_at)
            Timestamp.internalBinaryWrite(message.sent_at, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 6; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string type = 7; */
        if (message.type !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.type);
        /* optional string user_id = 8; */
        if (message.user_id !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.user_id);
        /* fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.Properties properties = 9; */
        if (message.properties)
            CohortingEvent_Properties.internalBinaryWrite(message.properties, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.CohortingEvent
 */
export const CohortingEvent = new CohortingEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CohortingEvent_Properties$Type extends MessageType<CohortingEvent_Properties> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.Properties", [
            { no: 1, name: "core", kind: "message", T: () => Core },
            { no: 2, name: "fubo_context", kind: "message", localName: "fubo_context", T: () => FuboContext },
            { no: 3, name: "user_properties", kind: "message", localName: "user_properties", T: () => UserProperties },
            { no: 4, name: "app_context", kind: "message", localName: "app_context", T: () => AppContext },
            { no: 5, name: "device", kind: "message", T: () => Device },
            { no: 6, name: "location", kind: "message", T: () => Location },
            { no: 7, name: "cohorting", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Cohorting },
            { no: 8, name: "navigation", kind: "message", T: () => Navigation }
        ]);
    }
    create(value?: PartialMessage<CohortingEvent_Properties>): CohortingEvent_Properties {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cohorting = [];
        if (value !== undefined)
            reflectionMergePartial<CohortingEvent_Properties>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CohortingEvent_Properties): CohortingEvent_Properties {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* fubo.tv.proto.common.v3.generic.Core core */ 1:
                    message.core = Core.internalBinaryRead(reader, reader.uint32(), options, message.core);
                    break;
                case /* fubo.tv.proto.common.v3.generic.FuboContext fubo_context */ 2:
                    message.fubo_context = FuboContext.internalBinaryRead(reader, reader.uint32(), options, message.fubo_context);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.UserProperties user_properties */ 3:
                    message.user_properties = UserProperties.internalBinaryRead(reader, reader.uint32(), options, message.user_properties);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.AppContext app_context */ 4:
                    message.app_context = AppContext.internalBinaryRead(reader, reader.uint32(), options, message.app_context);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Device device */ 5:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Location location */ 6:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting */ 7:
                    message.cohorting.push(Cohorting.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Navigation navigation */ 8:
                    message.navigation = Navigation.internalBinaryRead(reader, reader.uint32(), options, message.navigation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CohortingEvent_Properties, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* fubo.tv.proto.common.v3.generic.Core core = 1; */
        if (message.core)
            Core.internalBinaryWrite(message.core, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* fubo.tv.proto.common.v3.generic.FuboContext fubo_context = 2; */
        if (message.fubo_context)
            FuboContext.internalBinaryWrite(message.fubo_context, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.UserProperties user_properties = 3; */
        if (message.user_properties)
            UserProperties.internalBinaryWrite(message.user_properties, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.AppContext app_context = 4; */
        if (message.app_context)
            AppContext.internalBinaryWrite(message.app_context, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Device device = 5; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Location location = 6; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting = 7; */
        for (let i = 0; i < message.cohorting.length; i++)
            Cohorting.internalBinaryWrite(message.cohorting[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Navigation navigation = 8; */
        if (message.navigation)
            Navigation.internalBinaryWrite(message.navigation, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.CohortingEvent.Properties
 */
export const CohortingEvent_Properties = new CohortingEvent_Properties$Type();
